import * as React from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m 18.480132,12.019869 a 1.79,1.79 0 0 1 -0.51,1.28 l -10.380001,10.36 a 1.25,1.25 0 0 1 -1.76,-1.77 l 9.860001,-9.87 -9.860001,-9.86 a 1.25,1.25 0 0 1 1.76,-1.77000003 L 17.970132,10.739869 a 1.81,1.81 0 0 1 0.51,1.28 z" }));
export default SvgArrowRight;
